import React from "react";
import { Select } from "semantic-ui-react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { setCity } from "../../../redux/actions/city";
import FormSubscription from "./Components/formSubscription/formSubscription";
import "./styles/styles.css";
const countryOptions = [
  { key: "Tegucigalpa", value: "Tegucigalpa", text: "Tegucigalpa" },
  { key: "SPS", value: "SPS", text: "SPS" },
  { key: "La Ceiba", value: "La Ceiba", text: "La Ceiba" },
];

const FooterMain = ({ setCity, city }) => {
  const handleCityChange = (e, { value }) => {
    setCity(value);
  };

  return (
    <footer className="page-footer font-small lighten-5 pt-4 containerFooter">
      <div className="container text-center text-md-left text-dark">
        <div className="row">
          <hr className="clearfix w-100 d-md-none" />
          <div className="col-md-6 col-lg-3 mx-auto my-md-4 my-0 mt-4 mb-1">
            <h5 className="text-uppercase mb-4">Informativo</h5>
            <ul className="list-unstyled">
              <li>
                <p>
                  <Link to="/purchases" className="text-dark">
                    Condiciones de uso
                  </Link>
                </p>
              </li>
              {false && (
                <>
                  <li>
                    <p>
                      <a href="#!" className="text-dark">
                        Pedidos
                      </a>
                    </p>
                  </li>
                  <li>
                    <p>
                      <a href="#!" className="text-dark">
                        Envíos
                      </a>
                    </p>
                  </li>
                  <li>
                    <p>
                      <a href="#!" className="text-dark">
                        Sobre nosotros
                      </a>
                    </p>
                  </li>
                </>
              )}
              <li>
                <p>
                  <Link to="/faqs" className="text-dark">
                    Preguntas frecuentes
                  </Link>
                </p>
              </li>
            </ul>
            <div
              className="row center-cards"
              style={{
                marginLeft: 1,
                alignItems: "center",
              }}
            >
              <img
                src="/assets/icons/visa-logo.png"
                alt="visa-logo"
                className="iconCard"
              />
              <img
                src="/assets/icons/mastercard-logo.png"
                className="iconCard"
                alt="mastercard-logo"
              />
              <img
                src="/assets/icons/amex-logo.png"
                style={{ width: "14.5%" }}
                className="iconCard"
                alt="amex-logo"
              />
            </div>
          </div>
          <hr className="clearfix w-100 d-md-none" />
          <div className="col-md-6 col-lg-3 mx-auto my-md-4 my-0 mt-4 mb-1">
            <h5 className="text-uppercase mb-4">Visítanos</h5>
            <Select
              placeholder="Seleccione la ciudad..."
              options={countryOptions}
              onChange={handleCityChange}
            />
            <ul className="list-unstyled pt-3">
              <li>
                <p>
                  <i className="fas fa-home mr-3"></i>
                  Dirección de nuestras tiendas:{" "}
                  {city === "Tegucigalpa"
                    ? "Modalidad en línea únicamente "
                    : null}
                  {city === "SPS"
                    ? "Col. Trejo, 26 avenida, 11 y 12 calle, Casa N. 1127"
                    : null}
                  {city === "La Ceiba"
                    ? "Residencial El Toronjal 2, de la calle Agropecuaria Popular a la UTH "
                    : null}
                </p>
                <p>
                  <i className="fas fa-clock mr-3"></i>
                  Horarios de atención: Lunes a Sábado 8:00 AM a 5:00 PM
                </p>
              </li>
            </ul>
          </div>
          <div className="col-md-6 col-lg-3 mx-auto my-md-4 my-0 mt-4 mb-1">
            <h5 className="text-uppercase mb-4">Información</h5>

            <ul className="list-unstyled pt-3">
              <li>
                <p className="pb-3">
                  <i className="fas fa-envelope mr-3"></i>{" "}
                  lafloristeriahn@gmail.com
                </p>
              </li>
              <li>
                <p className="m-0">WhatsApp SPS: +504 8732-4880</p>
                <p className="m-0">WhatsApp TGA: +504 3353-7895</p>
                <p className="m-0">WhatsApp CBA: +504 9997-7237</p>
              </li>
              <br></br> <br></br>
              <li className="social">
                <div className="containerSocial">
                  <h5 className="text-uppercase mb-4">Redes sociales</h5>
                  <a
                    href="https://www.facebook.com/lafloristeriahn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/floristeria-honduras-dev.appspot.com/o/socialNetworks%2Ffacebook.png?alt=media&token=c868ddfa-5012-4dd2-a55f-7de0f85ecae1"
                      className="imagenFacebook"
                      alt="@lafloristeriahn"
                    />
                  </a>

                  <a
                    href="https://www.instagram.com/lafloristeriahn_/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/floristeria-honduras-dev.appspot.com/o/socialNetworks%2Finstagram-bosquejado.png?alt=media&token=622f3169-edcc-4790-ac2f-2d3f97d114b3"
                      className="imagenInstagram"
                      alt="@lafloristeriahn_"
                    />
                  </a>
                </div>
              </li>
            </ul>
          </div>
          <FormSubscription />
          <hr className="clearfix w-100 d-md-none" />
        </div>
      </div>
      <div className="text-center py-3 text-dark containerCopyRight">
        © 2020 Copyright:{" "}
        <a href="/" className="text-dark">
          La Floristería Honduras
        </a>
        <div>
          <a href="http://www.yourappland.com/es/">
            <img
              className="brand-logo"
              src="/assets/appland2.png"
              alt="appland-logo"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

const mapStateToProps = ({ city }) => ({
  city: city.city,
});

export default withRouter(connect(mapStateToProps, { setCity })(FooterMain));
